import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import errorSlice from "../../Services/errorSlice";
import usersService from "../../Services/users.service";
import labFormService from "../../Services/labForm.service";
import labService from "../../Services/lab.service";

const initialState = {
  loading: false,
  result: [],
  disable_department_detail: true,
  disable_lab_form: true,
  disable_patient_type: true,
  count_in_progress: 0,
  count_reported: 0,
  count_partial_report: 0,

  detailLoading: false,
  detailResult: null,
  detailItem: [],
};
export const labList = createAsyncThunk(
  "lab/list",
  async (values, thunkAPI) => {
    try {
      const result = await labService.list(values).then((respone) => {
        const { data } = respone;
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const labDetail = createAsyncThunk(
  "lab/detail",
  async (lab_order_id, thunkAPI) => {
    try {
      const result = await labService.detail(lab_order_id).then((respone) => {
        const { data } = respone;
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const labSlice = createSlice({
  name: "labSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(labList.pending, (state, action) => {
      state.loading = true;
      state.result = [];
      state.count_in_progress = 0;
      state.count_reported = 0;
      state.count_partial_report = 0;
    });
    builder.addCase(labList.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload.result;
      state.disable_department_detail =
        action.payload.disable_department_detail;
      state.disable_lab_form = action.payload.disable_lab_form;
      state.disable_patient_type = action.payload.disable_patient_type;
      state.count_in_progress = action.payload.count_in_progress;
      state.count_reported = action.payload.count_reported;
      state.count_partial_report = action.payload.count_partial_report;
    });
    builder.addCase(labList.rejected, (state, action) => {
      state.loading = false;
      state.result = [];
      state.count_in_progress = 0;
      state.count_reported = 0;
      state.count_partial_report = 0;
    });

    builder.addCase(labDetail.pending, (state, action) => {
      state.detailLoading = true;
      state.detailResult = null;
      state.detailItem = [];
    });
    builder.addCase(labDetail.fulfilled, (state, action) => {
      state.detailLoading = false;
      state.detailResult = action.payload.result.detail;
      state.detailItem = action.payload.result.item;
    });
    builder.addCase(labDetail.rejected, (state, action) => {
      state.detailLoading = false;
      state.detailResult = null;
      state.detailItem = [];
    });
  },
});

export const { reducer } = labSlice.actions;

export default labSlice.reducer;
